import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";
import RuvnlSimulationIndex from "./SimulateProcurement/SimulationIndex";
import { getSurplusharayanaSession } from "../../../Rest_api/RestApi";
import { setHPPCOptimizerDateRange } from "../../../store/state/SurplusDeficitOptimization/OptimizerDate";
import { setOptimizerHPPCSession } from "../../../store/state/SurplusDeficitOptimization/OptimizerSession";
import { setOptimizerHPPCSessionToken } from "../../../store/state/SurplusDeficitOptimization/OptimizerSessionToken";
import { useDispatch, useSelector } from "react-redux";
import PowerIndex from "./PowerProcurement/PowerIndex";
import ModArchive from "./ModArchive/ModArchive";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getSurplusharayanaSession();
      if (data) {
        dispatch(
          setHPPCOptimizerDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerHPPCSession(data.session));
        dispatch(setOptimizerHPPCSessionToken(data.session_token));
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "Surplus":
        return <RuvnlSimulationIndex />;
      case "archive":
        return <ModArchive />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
